import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-messenger-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessengerSettingsComponent {}
